<template>
   <div id="container" style="    width: 100%;padding: 20px 40px;">
      <a-spin :spinning="reloading">
         <Font></Font>
         <div style="display: flex;margin-bottom: 20px;"> <a-range-picker format="YYYY-MM-DD" v-model:value="rangeTime"
               @change="changeTime" style="width: 500px;" />
            <a-input v-model:value="title" placeholder="搜索内容" allowClear @pressEnter="onSearch" />
            <a-button type="primary" style="width: 100px;background: #00b2b9;
               border-color: #00b2b9;" @click="onSearch">
               <template #icon>
                  <SearchOutlined style="color: white;"/>
               </template>
            </a-button>
         </div>
         <div :style="scrollView" @scroll="handleScroll" class="scrollView">
            <div>
               <Report :report="item" v-for="item, index in reportList" v-bind:key="item"></Report>
            </div>
            <div v-if="reportList.length == pagination.total">
               <Bottom></Bottom>
            </div>
         </div>
      </a-spin>
   </div>
   <!--<a-modal  v-model:visible="visible" :bodyStyle="{height:'90%',width:'500px'}">
       <iframe src="https://www.enplus.org.cn/vuePostertest/#/?id=129512&companyId=32&loading=true"></iframe>
    </a-modal>-->
</template>
<script>
import { SearchOutlined } from '@ant-design/icons-vue';
import { myReportList } from '../../views/js/index'
import { reactive, watch, ref, onMounted } from 'vue'
import store from '@/store'
import dayjs from 'dayjs'
import Report from '../dataPollComponent/Report.vue'
import Font from '../articleComponent/Font.vue'
import Bottom from '../articleComponent/Bottom.vue'
export default {
   components: { Report, SearchOutlined, Font, Bottom },
   name: 'reportLibrary',
   setup() {
      watch(() => store.getters.company, (val) => {
         if (val) {
            var height = document.getElementById('container').offsetHeight
            scrollView.value = { height: (height - 120) + 'px', overflow: 'auto' }
            pagination.companyId = store.getters.company.companyId
            toShowTable()
         }
      })
      onMounted(() => {
         var height = document.getElementById('container').offsetHeight
     
         scrollView.value = { height: (height -120) + 'px', overflow: 'auto' }
         if (store.getters.company) {
            toShowTable()
         }
      })
      const toShowTable = () => {
         reloading.value = true
         var startTime = ''
         var endTime = ''
         if (rangeTime.value[0] != '') {
            startTime = dayjs(rangeTime.value[0]).format(dateFormat) + " 00:00:00"
            endTime = dayjs(rangeTime.value[1]).format(dateFormat) + " 23:59:59"
         }
         var list = { current: pagination.current, size: 10, keyWord: title.value, startTime: startTime, endTime: endTime }
         myReportList({ id: store.getters.company.companyId, data: list }).then((res) => {
            pagination.total = res.data.total
            for (var i in res.data.records) {
               res.data.records[i].new = formatDatetoNew(res.data.records[i].createTime)
            }
            reportList.value = reportList.value.concat(res.data.records)
            reloading.value = false
         })
      }
      const pagination = reactive({
         current: 1,
         size: 10,
         companyId: '',
         total: 0
      })
      const reportList = ref([])
      const scrollView = ref('')
      const dateFormat = 'YYYY-MM-DD';
      const handleScroll = (e) => {
         let scrollTop = e.target.scrollTop; //滑入屏幕滚动条滚动时，距离顶部的距离
         let windowHeitht = e.target.clientHeight; //能看到的页面的高度
         let scrollHeight = e.target.scrollHeight; //监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
         let total = scrollTop + windowHeitht
         if (scrollHeight - total < 20) {
            if (reportList.value.length != pagination.total) {
               if (reloading.value == false) {
                  pagination.current = pagination.current + 1
                  toShowTable()
               }
            }
         }
      }
      const reloading = ref(false)
      const visible = ref(true)
      const title = ref('')
      const rangeTime = ref(['', ''])
      const changeTime = () => {
         if (rangeTime.value == null) {
            rangeTime.value = ['', '']
         }
         onSearch()
      }
      const formatDatetoNew = (time) => {
         // 获取当前时间
         var currentDate = dayjs();
         // 指定某个时间
         var targetDate = dayjs('time');
         // 计算两个时间之间的天数差异
         var daysDiff = targetDate.diff(currentDate, 'day');
         if (daysDiff < -1 || daysDiff < 0 || daysDiff == 0) {
            return true
         }
         else return false
      }
      const onSearch = () => {
         reportList.value = []
         pagination.current = 1

         toShowTable()
      }
      return {
         onSearch,
         formatDatetoNew,
         changeTime,
         rangeTime,
         title,
         visible,
         reloading,
         scrollView,
         handleScroll,
         reportList,
         toShowTable,
         pagination,
      }
   }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.scrollView {
   margin: 10px 0px;
}
</style>